module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_d/aoj_d-2-43e1620d45823b6c75fcb4ed378d4ee4.jpg";